import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { BrowserOption, TextTransform } from '@grupo-constant/next-dtype/types';
import { LangDefinition, TranslocoService } from '@ngneat/transloco';
import { langDefinition } from '../../config/app.config';
import { LocaleString } from '../../translate/localeString.model';

@Component({
    selector: 'localetext-component',
    templateUrl: './localetext.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LocaleTextComponent implements OnInit {

    @Input() control: FormControl; // required
    @Input() caption: string;
    @Input() placeholder: string;
    @Input() maxLength: number;
    @Input() minLength: number;
    @Input() transform = 'NONE';
    @Input() hint: string;
    @Input() type: string; // required LANGUAGETEXT or LANGUAGETEXTAREA
    @Input() required: boolean = false;
    @Input() compact = false;
    @Input() useFlags = false;
    @Input() cols = 0;
    @Input() rows = 0;
    @Input() browser: BrowserOption;

    availableLocales: LangDefinition[];
    locale: string;

    localeControls: Map<string, FormControl> = new Map();

    constructor(private translocoService: TranslocoService) { }

    ngOnInit() {
        this.availableLocales = this.translocoService.getAvailableLangs().map(lang => langDefinition[lang]);
        this.locale = this.translocoService.getActiveLang();

        this.control.addValidators((ctrl: FormControl) => {
            if (this.required && (!ctrl.value || Object.keys(ctrl.value).length === 0 || this.localeStringIsEmpty())) {
                return { required: true };
            }
            return null;
        });
        this.control.setValue(this.control.value ?? new LocaleString(), { emitEvent: false });

        let control: FormControl;
        for (const locale of this.availableLocales) {
            control = new FormControl({ value: this.control.value ? this.control.value[locale.id] : '', disabled: this.control.disabled });
            control.valueChanges.subscribe((value) => {
                if (this.transform && this.transform !== 'NONE') {
                    if (value) {
                        if (this.transform === 'UPPERCASE') {
                            value = value.trim().toUpperCase();
                        } else if (this.transform === 'LOWERCASE') {
                            value = value.trim().toLowerCase();
                        }
                    }
                }
                this.localeControls.get(locale.id).setValue(value, { emitEvent: false });
                this.control.value[locale.id] = value;
                this.control.setValue(this.control.value);
            });
            control.addValidators([Validators.minLength(this.minLength), Validators.maxLength(this.maxLength)]);
            this.localeControls.set(locale.id, control);
        }
    }

    controlsAreTouched() {
        for (const control of this.localeControls.values()) {
            if (!control.disabled && control.touched) {
                return true;
            }
        }
        return false;
    }

    controlsAreEmpty() {
        for (const key of Object.keys(this.control.value)) {
            if (this.control.value[key]) {
                return false;
            }
        }
        return true;
    }

    localeChange(event) {
        this.locale = event.value;
    }

    localeStringIsEmpty() {
        for (const str of Object.values(this.control.value as LocaleString)) {
            if (str.length > 0) {
                return false;
            }
        }
        return true;
    }

    validate() {
        for (const control of this.localeControls.values()) {
            control.markAsTouched();
            if (!control.valid) {
                return false;
            }
        }
        return true;
    }

}
